__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "dvs-support-dcp-mfe-legacy";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@dtna/csgna-core-dcp-lib-ui-maps", "1.8.1", () => (Promise.all([__webpack_require__.e(898), __webpack_require__.e(279), __webpack_require__.e(979), __webpack_require__.e(422), __webpack_require__.e(170), __webpack_require__.e(202)]).then(() => (() => (__webpack_require__(53279))))));
			register("@dtna/dvs-core-dcp-ui-libraries", "6.23.0", () => (Promise.all([__webpack_require__.e(898), __webpack_require__.e(869), __webpack_require__.e(852), __webpack_require__.e(564), __webpack_require__.e(422), __webpack_require__.e(94), __webpack_require__.e(894), __webpack_require__.e(550)]).then(() => (() => (__webpack_require__(67564))))));
			register("@dtna/dvs-core-dcp-ui-libraries", "6.23.1", () => (Promise.all([__webpack_require__.e(898), __webpack_require__.e(869), __webpack_require__.e(852), __webpack_require__.e(191), __webpack_require__.e(908), __webpack_require__.e(422), __webpack_require__.e(94), __webpack_require__.e(894), __webpack_require__.e(757)]).then(() => (() => (__webpack_require__(908))))));
			register("@here/maps-api-for-javascript", "1.64.1", () => (__webpack_require__.e(606).then(() => (() => (__webpack_require__(60606))))));
			register("react-dom", "16.14.0", () => (Promise.all([__webpack_require__.e(706), __webpack_require__.e(422)]).then(() => (() => (__webpack_require__(21706))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(845), __webpack_require__.e(422), __webpack_require__.e(94), __webpack_require__.e(86)]).then(() => (() => (__webpack_require__(56845))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(399), __webpack_require__.e(422), __webpack_require__.e(94)]).then(() => (() => (__webpack_require__(56399))))));
			register("react", "16.14.0", () => (__webpack_require__.e(247).then(() => (() => (__webpack_require__(5247))))));
			register("redux", "4.0.1", () => (__webpack_require__.e(889).then(() => (() => (__webpack_require__(33889))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(892).then(() => (() => (__webpack_require__(73892))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(967).then(() => (() => (__webpack_require__(68967))))));
			initExternal(36135);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};